module.exports = __webpack_public_path__ + "media/nunitosans/NunitoSans-Bold-e6f83449.woff";